// extracted by mini-css-extract-plugin
export default {"toinfo":"details_toinfo__DRIwW"};